import { render, staticRenderFns } from "./ApplicationSettingsTab.vue?vue&type=template&id=2bae0256&scoped=true&"
import script from "./ApplicationSettingsTab.vue?vue&type=script&lang=js&"
export * from "./ApplicationSettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationSettingsTab.vue?vue&type=style&index=0&id=2bae0256&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bae0256",
  null
  
)

export default component.exports